<div id="main" class="myw-content iom-land flex-fill d-flex h-100">
    <div class="myw-inner myw-container"> 
        <div class="row align-items-center h-100">
            <div class="col px-5">
                <div class="iom-land-img"><img src="assets/images/land-img1.png" alt="" /></div>
            </div>
            <div class="col">
                <div class="d-flex flex-column justify-content-end">
                    <div class="mt-2 iom-subtext">I am your</div>
                    <h2 class="iom-headtitle">Intelligent Opportunity Miner</h2>
                    <div class="iom-subtext">Based on Artificial intelligence, machine learning and analytics, I self- learn based on past and current information continuously, to provide the most
                        appropriate ways to reduce/optimize your incidents. I help drive your automation agenda to create your automation blueprint.</div>
                    <div class="my-4">
                        <a (click)="navigateToDeepdive()" class="btn-lg btn-primary" title="Get Started" style="cursor: pointer;">Get Started</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

